export const globalDataTableStyle = {
  headCells: {
    style: {
      fontWeight: 'bold',
    },
  }
};